import {
    CustomAlarmActionAmount,
    CustomAlarmModalTextContent,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.model';

export const CUSTOM_ALARM_DELETION_TEXTS: Record<CustomAlarmActionAmount, CustomAlarmModalTextContent> = {
    single: {
        headerText: 'settings.devices.custom-alarms.delete.modal.title.single',
        bodyText: 'settings.devices.custom-alarms.delete.modal.description.single',
    },
    multiple: {
        headerText: 'settings.devices.custom-alarms.delete.modal.title.multiple',
        bodyText: 'settings.devices.custom-alarms.delete.modal.description.multiple',
    },
};
